const ELEMENT_NAME = 'translate_to_local_language_button';
const ELEMENT_TYPE = 'button';
const ELEMENT = {
    name: ELEMENT_NAME,
    type: ELEMENT_TYPE,
};
export const DEFAULT_SOURCE_INFO = {
    element: ELEMENT,
};
export const ACTION_TYPE = 'click';
